import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=65fb070c&"
import script from "./Knowledge.vue?vue&type=script&lang=js&"
export * from "./Knowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports